import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
// metrics
import {metrics} from '~/vendor/metrics';
import {Button, Link} from '@customink/pigment-react';

const propTypes = {
  dismiss: PropTypes.func,
  primaryAction: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class ShoppingCartConfirmNotification extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    dismiss() {},
    primaryAction() {}
  };

  componentDidMount() {
    metrics.pageViewTag('/ndx/cart');
  }

  cancel = () => {
    metrics.fireEvent('multi item', 'cart icon', 'return to lab');
    this.props.dismiss();
  };

  confirm = () => {
    metrics.fireEvent('multi item', 'cart icon', 'continue to cart');
    this.props.primaryAction();
  };

  render() {
    return (
      <Notification
        dismiss={this.cancel}
        title="Continue without saving?"
        type="ERROR">
        <p className="ndx-cta1">
          You will lose any unsaved changes by <br /> continuing to your cart.
        </p>
        <Button
          size="large"
          variant="Primary"
          className="notification-cta"
          data-testid="continue-without-saving"
          onClick={this.confirm}>
          Continue without saving?
        </Button>
        <br />
        <br />
        <Link className="ndx-cta-Link" button onClick={this.cancel}>
          cancel
        </Link>
      </Notification>
    );
  }
}

ShoppingCartConfirmNotification.displayName = 'ShoppingCartConfirmNotification';
